var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-form",
        {
          ref: "dataForm",
          attrs: {
            model: _vm.childData,
            rules: _vm.rules,
            "label-position": "right",
            "label-width": "130px"
          }
        },
        [
          _vm.isDetail
            ? _c(
                "div",
                { staticClass: "information" },
                [
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "回访工单号" } },
                            [_c("span", [_vm._v(_vm._s(_vm.flowNum))])]
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "联系人" } },
                            [
                              _c(
                                "el-tooltip",
                                {
                                  attrs: {
                                    effect: "dark",
                                    content: _vm.childData.feebackUserName,
                                    placement: "top-start",
                                    disabled: _vm.tooltipDisabled(
                                      _vm.childData.feebackUserName,
                                      10
                                    )
                                  }
                                },
                                [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.trimStr(
                                          _vm.childData.feebackUserName,
                                          10
                                        )
                                      )
                                    )
                                  ])
                                ]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "联系人电话" } },
                            [
                              _c("span", [
                                _vm._v(_vm._s(_vm.childData.feebackUserMobile))
                              ])
                            ]
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "业主住址" } },
                            [
                              _c(
                                "el-tooltip",
                                {
                                  attrs: {
                                    effect: "dark",
                                    content: _vm.childData.hostAdress,
                                    placement: "top-start",
                                    disabled: _vm.tooltipDisabled(
                                      _vm.childData.hostAdress,
                                      10
                                    )
                                  }
                                },
                                [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.trimStr(
                                          _vm.childData.hostAdress,
                                          10
                                        )
                                      )
                                    )
                                  ])
                                ]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "回访人" } },
                            [
                              _c(
                                "el-tooltip",
                                {
                                  attrs: {
                                    effect: "dark",
                                    content: _vm.childData.userName,
                                    placement: "top-start",
                                    disabled: _vm.tooltipDisabled(
                                      _vm.childData.userName,
                                      10
                                    )
                                  }
                                },
                                [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.trimStr(_vm.childData.userName, 10)
                                      )
                                    )
                                  ])
                                ]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "回访人部门" } },
                            [
                              _c(
                                "el-tooltip",
                                {
                                  attrs: {
                                    effect: "dark",
                                    content: _vm.childData.deptName,
                                    placement: "top-start",
                                    disabled: _vm.tooltipDisabled(
                                      _vm.childData.deptName,
                                      10
                                    )
                                  }
                                },
                                [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.trimStr(_vm.childData.deptName, 10)
                                      )
                                    )
                                  ])
                                ]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "回访意见" } },
                            [
                              _c(
                                "el-tooltip",
                                {
                                  attrs: {
                                    effect: "dark",
                                    content: _vm.childData.feebackRemark,
                                    placement: "top-start",
                                    disabled: _vm.tooltipDisabled(
                                      _vm.childData.feebackRemark,
                                      10
                                    )
                                  }
                                },
                                [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.trimStr(
                                          _vm.childData.feebackRemark,
                                          10
                                        )
                                      )
                                    )
                                  ])
                                ]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c("el-form-item", { attrs: { label: "满意类型" } }, [
                            _c("span", [
                              _vm._v(_vm._s(_vm.childData.visitRatingValue))
                            ])
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            : _c(
                "div",
                [
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "回访工单号" } },
                            [
                              _c("el-input", {
                                staticClass: "form-item-width",
                                attrs: { disabled: "" },
                                model: {
                                  value: _vm.flowNum,
                                  callback: function($$v) {
                                    _vm.flowNum = $$v
                                  },
                                  expression: "flowNum"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "联系人",
                                prop: "feebackUserName"
                              }
                            },
                            [
                              _c("el-input", {
                                staticClass: "form-item-width",
                                attrs: { placeholder: "请输入联系人" },
                                model: {
                                  value: _vm.childData.feebackUserName,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.childData,
                                      "feebackUserName",
                                      $$v
                                    )
                                  },
                                  expression: "childData.feebackUserName"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "联系人电话",
                                prop: "feebackUserMobile"
                              }
                            },
                            [
                              _c("el-input", {
                                staticClass: "form-item-width",
                                attrs: { placeholder: "请输入联系人电话" },
                                model: {
                                  value: _vm.childData.feebackUserMobile,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.childData,
                                      "feebackUserMobile",
                                      $$v
                                    )
                                  },
                                  expression: "childData.feebackUserMobile"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: { label: "业主住址", prop: "hostAdress" }
                            },
                            [
                              _c("el-input", {
                                staticClass: "form-item-width",
                                attrs: { placeholder: "请输入业主地址" },
                                model: {
                                  value: _vm.childData.hostAdress,
                                  callback: function($$v) {
                                    _vm.$set(_vm.childData, "hostAdress", $$v)
                                  },
                                  expression: "childData.hostAdress"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "回访人部门", prop: "deptId" } },
                            [
                              _c("el-cascader", {
                                staticStyle: { width: "250px" },
                                attrs: {
                                  clearable: "",
                                  "change-on-select": "",
                                  "show-all-levels": false,
                                  options: _vm.deptOptions,
                                  props: _vm.propstree
                                },
                                on: {
                                  change: function($event) {
                                    return _vm.getCustomerOption(
                                      _vm.childData.deptId
                                    )
                                  }
                                },
                                model: {
                                  value: _vm.childData.deptId,
                                  callback: function($$v) {
                                    _vm.$set(_vm.childData, "deptId", $$v)
                                  },
                                  expression: "childData.deptId"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "回访人", prop: "userId" } },
                            [
                              _c(
                                "el-select",
                                {
                                  staticStyle: { width: "250px" },
                                  attrs: {
                                    clearable: "",
                                    placeholder: "请选择回访人"
                                  },
                                  model: {
                                    value: _vm.childData.userId,
                                    callback: function($$v) {
                                      _vm.$set(_vm.childData, "userId", $$v)
                                    },
                                    expression: "childData.userId"
                                  }
                                },
                                _vm._l(_vm.customerOption, function(item) {
                                  return _c("el-option", {
                                    key: item.userId,
                                    attrs: {
                                      label: item.userName,
                                      value: item.userId
                                    }
                                  })
                                }),
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "回访意见",
                                prop: "feebackRemark"
                              }
                            },
                            [
                              _c("el-input", {
                                staticStyle: { width: "250px" },
                                attrs: {
                                  autosize: "",
                                  placeholder: "请输入回访意见"
                                },
                                model: {
                                  value: _vm.childData.feebackRemark,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.childData,
                                      "feebackRemark",
                                      $$v
                                    )
                                  },
                                  expression: "childData.feebackRemark"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "满意类型",
                                prop: "feebackRating"
                              }
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  staticStyle: { width: "250px" },
                                  attrs: {
                                    clearable: "",
                                    placeholder: "请选择满意类型"
                                  },
                                  model: {
                                    value: _vm.childData.feebackRating,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.childData,
                                        "feebackRating",
                                        $$v
                                      )
                                    },
                                    expression: "childData.feebackRating"
                                  }
                                },
                                _vm._l(_vm.satisfiedOption, function(item) {
                                  return _c("el-option", {
                                    key: item.value,
                                    attrs: {
                                      label: item.name,
                                      value: item.value
                                    }
                                  })
                                }),
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
        ]
      ),
      !_vm.isDetail
        ? _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c("el-button", { on: { click: _vm.handCancle } }, [
                _vm._v(_vm._s(_vm.$t("button.cancel")))
              ]),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.handCreate } },
                [_vm._v(_vm._s(_vm.$t("button.confirm")))]
              )
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }